import { render, staticRenderFns } from "./file-card.vue.js?vue&type=template&id=4d88df62&scoped=true!=!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./file-card.vue?vue&type=template&id=4d88df62&scoped=true"
import script from "./file-card.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./file-card.vue?vue&type=script&lang=js"
export * from "./file-card.vue.js?vue&type=script&lang=js!=!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./file-card.vue?vue&type=script&lang=js"
import style0 from "./file-card.vue.scss?vue&type=style&index=0&id=4d88df62&lang=scss!=!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./file-card.vue?vue&type=style&index=0&id=4d88df62&lang=scss"
import style1 from "./file-card.vue.scss?vue&type=style&index=1&id=4d88df62&scoped=true&lang=scss!=!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./file-card.vue?vue&type=style&index=1&id=4d88df62&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88df62",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d88df62')) {
      api.createRecord('4d88df62', component.options)
    } else {
      api.reload('4d88df62', component.options)
    }
    module.hot.accept("./file-card.vue.js?vue&type=template&id=4d88df62&scoped=true!=!../../../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./file-card.vue?vue&type=template&id=4d88df62&scoped=true", function () {
      api.rerender('4d88df62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/components/ChatFrame/ChatExtract/components/file-show/components/file-card.vue"
export default component.exports